import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/company/{id}/houses',
  options: {
    arrayFormat: 'comma',
    createParams: ({ endPoint, params }) => {
      const { companyId, cityIds } = params;

      const result = { url: endPoint.replace('{id}', companyId) };

      if (cityIds?.length) result.params = { cityIds };

      return result;
    },
  },
});

export const useHousesQuery = ({
  params: { companyId, cityIds } = {},
  options,
} = {}) =>
  useQuery({
    params: { companyId, cityIds },
    options: { enabled: Boolean(companyId && cityIds?.length > 0), ...options },
  });
